import app from '../../app';
import { BooleanGambit } from '../IGambit';
export default class HiddenGambit extends BooleanGambit {
  key() {
    return app.translator.trans('core.lib.gambits.discussions.hidden.key', {}, true);
  }
  filterKey() {
    return 'hidden';
  }
  enabled() {
    return !!app.session.user;
  }
}
flarum.reg.add('core', 'common/query/discussions/HiddenGambit', HiddenGambit);